/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitCollectionRegistryV2 } from "../OrbitCollectionRegistryV2";

export class OrbitCollectionRegistryV2__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _addressRegistry: string,
    overrides?: Overrides
  ): Promise<OrbitCollectionRegistryV2> {
    return super.deploy(
      _addressRegistry,
      overrides || {}
    ) as Promise<OrbitCollectionRegistryV2>;
  }
  getDeployTransaction(
    _addressRegistry: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_addressRegistry, overrides || {});
  }
  attach(address: string): OrbitCollectionRegistryV2 {
    return super.attach(address) as OrbitCollectionRegistryV2;
  }
  connect(signer: Signer): OrbitCollectionRegistryV2__factory {
    return super.connect(signer) as OrbitCollectionRegistryV2__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitCollectionRegistryV2 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OrbitCollectionRegistryV2;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_addressRegistry",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "royality",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeReceipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
    ],
    name: "CollectionAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "collection",
        type: "address",
      },
    ],
    name: "CollectionRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "royality",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeReceipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
    ],
    name: "CollectionUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_royality",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeReceipient",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "addressRegistry",
    outputs: [
      {
        internalType: "contract IOrbitAddressRegistryV2",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "creator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "enabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "feeReceipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feeReceipientAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
    ],
    name: "remove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "royality",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "royalityFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_royality",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeReceipient",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
    ],
    name: "update",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "updateAddressRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
